export default {
  title: 'Resumen',
  table_title: 'Reservas',
  filters: {
    card_title: 'Filtros',
    today: 'Hoy',
    upcoming: 'Próximas',
    past: 'Pasadas',
    all: 'Todas',
    all_dates: 'Todo el período',
    pending: 'Pendiente de confirmación',
    canceled: 'Cancelada',
    removed: 'Eliminada',
    date_label: 'Fecha:',
    status_label: 'Estado:',
    source_label: 'Origen:',
    source_website: 'Sitio web',
    source_google: 'Google',
    search_label: 'Buscar:',
    search_placeholder: 'Buscar por nombre o apellido',
    custom_date_tooltip: 'Seleccionar una fecha concreta',
    active_label: 'Filtros activos:',
    clear_all: 'Borrar todo',
  },
  tooltips: {
    total_reservations: 'Total de reservas',
    total_guests: 'Total de comensales',
    refresh: 'Actualizar',
  },
  empty: {
    default: 'Aún no hay reservas.',
    filtered: 'Ninguna reserva coincide con los filtros.',
  },
  fields: {
    company: 'Restaurante',
    datetime: 'Fecha / hora',
    customer: 'Cliente',
    source: 'Origen',
    guests: 'Comensales',
    status: 'Estado',
    created_at: 'Creada el',
  },
  status: {
    confirmed: 'Confirmada',
    pending: 'En espera de aprobación',
    canceled: 'Cancelada',
    rejected: 'Rechazada',
    removed: 'Eliminada',
  },
  buttons: {
    details: 'Detalles',
    add_reservation: 'Añadir reserva',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar los datos',
  },
};
